<template>
  <div class="dashboard_left absolute">
    <div style="display:flex;flex-flow:column;height:100%">
      <div class="contain_top">
        <!-- 公共title -->
        <Top
          :name="$t('Equipment operation reference')"
          :show-button="false"
        ></Top>
        <div class="top_data">
          <EquipRun></EquipRun>
        </div>
      </div>
      <div class="contain_center">
        <!-- 公共title -->
        <Top :name="$t('Recent Events')" :show-button="false"></Top>
        <div class="top_data">
          <EquipWarning></EquipWarning>
        </div>
      </div>
      <div class="contain_footer">
        <!-- 公共title -->
        <div class="relative">
          <Top
            :name="$t('Diagnosis conclusion')"
            :show-button="true"
            :button-name="$t('Diagnostic Report')"
          ></Top>
        </div>
        <div class="footer_data">
          <Diagnosis></Diagnosis>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EquipRun from "./component/EquipRun";
import EquipWarning from "./component/EquipWarning";
import Diagnosis from "./component/Diagnosis";
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  components: {
    EquipRun,
    EquipWarning,
    Diagnosis
  }
};
</script>

<style scoped lang="scss">
@import url("../../../../assets/scss/common.scss");

.dashboard_left {
  width: 400px;
  height: 100%;
  top: -10px;
  left: 0;

  .contain_top,
  .contain_center,
  .contain_footer {
    display: flex;
    flex-flow: column;
    overflow: hidden;
    margin-bottom: 10px;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 20px 25px 10px;
    .top_data {
      flex: 1;
    }
  }
  .contain_top {
    flex: 1.8;
  }
  .contain_center {
    flex: 1.8;
  }
  .contain_footer {
    flex: 1;
    margin-bottom: 0;
    .footer_data {
      flex: 1;
    }
  }
}
</style>
